/**
 * Copyright (c) 2022 FMR LLC.
 * All Rights Reserved.
 * Fidelity Confidential Information.
 */

import { ClientConstants } from '@/client.constants';
import axios from 'axios';
import { CalculationRequestModel, CalculationResponseModel } from '../models/calculation-models';

export default class CalculationService {
    public static async getYields(
        bondType: string, 
        bondYield: number, 
        federalTax: number, 
        state: string, 
        stateTax: number, 
        localTax: number): Promise<CalculationResponseModel> {

        const requestModel = new CalculationRequestModel(bondType, bondYield, federalTax, state, stateTax, localTax);
        const config = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
            },
        };
        try {
            const response = await axios.post(ClientConstants.CALCULATIONS_URL, requestModel, config);
            const yields = new CalculationResponseModel(response.data);
            return yields;
        } catch (error) {
            throw new Error(ClientConstants.CALCULATIONS_REQUEST_ERROR + '\n' + error);
        }
    }
}